import {CheckboxIndicator, Checkbox as CheboxPrimitive} from '@radix-ui/react-checkbox'
import {
  ScrollArea, 
  ScrollAreaCorner, 
  ScrollAreaScrollbar, 
  ScrollAreaThumb, 
  ScrollAreaViewport,
} from '@radix-ui/react-scroll-area'

import {DIVIDER_HEIGHT} from '../constants/global'
import { styled } from './stitches.config'

export const Div = styled('div')
export const P = styled('p')
export const B = styled('b')
export const Span = styled('span', {
  variants: {
    flexFillSpace: {
      true: {
        flex: '1 0 0',
      },
    },
    noWrap: {
      true: {
        whiteSpace: 'nowrap',
      },
    },
  },
})

export const Container = styled('div', {
  maxWidth: '42rem',
  margin: 'auto',
  padding: '7rem 1rem 0 1rem',
  display: 'flex', 
  flexDirection: 'column', 
  variants: {
    inlineHeaderWithButtons: {
      true: {
        alignItems: 'center', 
        gap: '0.625rem', 
        alignSelf: 'stretch', 
        flex: '1 0 0',
        flexDirection: 'row',
        '> h1, > h2, > h3, > h4, > h5, > h6': {
          flex: '1 0 0',
          textAlign: 'left', 
          margin: 0,
        },
        margin: 0,
        padding: 0,

      },
    },
    section: {
      true: {
        padding: '2rem 1rem 0 1rem', 
      },
    },
    center: {
      true: {
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    stripPadding: {
      true: {
        padding: '0',
      },
    },
    expand: {
      true: {
        minHeight: '100vh',
        height: '100vh', 
        minWidth: '100vw',
      },
    },
    expandX: {
      true: {
        minWidth: '80vw',
        width: '80vw',
      },
    },
    dotted: {
      true: {
        $$dotSpace: '1.5rem',
        $$dotSize: '0.0625rem',
        background: `linear-gradient(90deg, $appBackground calc($$dotSpace - $$dotSize), transparent 1%) center,
                     linear-gradient($appBackground calc($$dotSpace - $$dotSize), transparent 1%) center, 
                     $solidBackground`,
        backgroundSize: '$$dotSpace $$dotSpace',
      },
    },
  },
})


export const defaultButtonStyle = {
  backgroundColor: '$elementBackground',
  color: '$highContrast',
  height: '2.75rem',
  border: 'none',
  borderRadius: '0.5rem',
  fontSize: 'medium',
  userSelect: 'none',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0 1rem 0 1rem',
  width: 'auto',
}

export const Button = styled('button', {
  ...defaultButtonStyle,

  '&:hover': {
    backgroundColor: '$elementHover',
  },
  '&:active': {
    backgroundColor: '$elementActive',
  },
  "&[data-state='open']": {
    backgroundColor: '$elementActive',
  },
  '&:disabled': {
    opacity: '30%',
    cursor: 'not-allowed',
  },

  variants: {

    gridCell: {
      true: {
        width: '100%',
        height: '100%',
        borderRadius: 0,
        position: 'relative',
        zindex: 2,
        padding: 0,
        margin: 0,
        backgroundColor: 'transparent',
        borderTop: '1px solid $separator',
        borderLeft: '1px solid $separator',
        borderRight: 'none',
        borderBottom: 'none',
        '&:hover': {
          backgroundColor: '$elementHover',
        },
        '&:active': {
          backgroundColor: '$elementActive',
        },
      },
    },
    
    search: {
      desktop: {
        width: '80%',
        marginBottom: '1rem',
        gap: '2rem',
      },
    },
    thin: {
      true: {
        height: '2.75rem',
        padding: '0 0.5rem 0 0.5rem',
      },
    },
    warning: {
      true: {
        backgroundColor: '$amber4',
        '&:hover': {
          backgroundColor: '$amber6',
        },
      },
    },
    block: {
      true: {
        width: '100%',
      },
    },
    icon: {
      true: {
        width: '2.75rem',
        background: 'none',
        padding: '0',
      },
    },
    active: {
      true: {
        backgroundColor: '$neutral6',
        '&:hover': { backgroundColor: '$elementHover' },
      },
    },
    /* Press and hold animation */
    animate: {
      true: {
        transition:
          'transform 250ms cubic-bezier(.2, .8, .4, 1), background-color 250ms ease-in-out',
        '&:hover': {
          transform: 'scale(1.05)',
        },
        '&:active': {
          transform: 'scale(0.95)',
        },
      },
    },
  },
})